import React from "react";
import PropTypes from "prop-types";
import { FaTrash, FaPen, FaPlus } from "react-icons/fa";
import Button from "./Button";
import "../styles/reviews.css";

const ReviewsSection = ({ reviews, onAdd, onEdit, onDelete }) => {
  return (
    <div className="reviews-section-fullwidth">
      <div className="reviews-header-row">
        <h2>Reviews</h2>
        <Button
          title={
            <>
              <FaPlus style={{ marginRight: 6 }} />
              Add review
            </>
          }
          className="float-right mb-2"
          onPress={onAdd}
          typeBtn="primary"
        />
      </div>
      <table className="reviews-table">
        <thead>
          <tr>
            <th>Number</th>
            <th>Name</th>
            <th>Location</th>
            <th>Description</th>
            <th style={{ textAlign: "center" }}>Picture</th>
            <th style={{ textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reviews.map((review, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{review.name}</td>
              <td>{review.location}</td>
              <td>{review.description}</td>
              <td style={{ textAlign: "center" }}>
                <img src={review.picture} alt={review.name} className="review-picture" width={40} height={40} />
              </td>
              <td>
                <view className="actions">
                  <span className="action-btn text-success px-1" title="Edit" onClick={() => onEdit && onEdit(idx)}>
                    <FaPen />
                  </span>
                  <span
                    className="action-btn text-danger px-1"
                    title="Delete"
                    onClick={() => onDelete && onDelete(idx)}
                  >
                    <FaTrash />
                  </span>
                </view>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ReviewsSection.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      location: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      picture: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ReviewsSection;
